import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../types/api-response";
import axios from "../../utils/axiosInceptor";
import { apiV1Endpoint } from "./endpoints";

type BusinessUnit = {
  businessUnitId: string;
  businessUnitName: string;
  numberOfUnits: number;
};

type UseGetBusinessUnitsOptions = {
  isEnabled?: boolean;
};

const getBusinessUnits = async (orgId: string) => {
  const url = `${apiV1Endpoint}/businessUnitmaster/list`;
  const response = await axios.get<ApiResponse<BusinessUnit[]>>(url, { params: { orgId } });
  return response.data.result;
};

export const useGetBusinessUnits = (options: UseGetBusinessUnitsOptions = {}) => {
  const { isEnabled } = options;

  const orgId = JSON.parse(localStorage.getItem("login-response"))?.orgId;

  const { data, isLoading } = useQuery({
    queryKey: ["business-units", orgId],
    queryFn: () => getBusinessUnits(orgId),
    enabled: !!orgId && isEnabled,
  });

  return {
    businessUnits: data ?? [],
    isLoadingBusinessUnits: isLoading,
  };
};
